import { useFormik } from "formik";
import React from "react";
import { useDispatchWrapper } from "../../../../../../hooks";


import {
  AlertTitle,
  Grid,
  List,
  ListItem,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import {
  CustomFormLabel,
  CustomTextField,
} from "../../../../../../components/formsComponents";
import { FileUpload } from "../../../../../../features/FileUpload/components/FileUpload";
import { ErrorMessage } from "../../../../../../components/ErrorMessage/ErrorMessage";
import { Dialog } from "../../../../../../components/Dialogs/Dialog";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../../../../../redux/messages/messagesActions";
import { api } from "../../../../../../api/api";
import { CustomAlert } from "../../../../../../components/formsComponents/CustomAlert";
import { DownloadForOfflineOutlined } from "@mui/icons-material";
import { uploadFile } from "../../../../../../features/FileUpload/utils";

interface IImportVehcileDriverDataProps {
  open: boolean;
  customer_id: number;
  customer_policy_id: number;
  customer_name: string;
  type: "VEHICLE" | "DRIVER";
  policy_type: "AUTO" | "COMMAUTO";
  onClose: () => void;
  onComplete: () => void;
}

interface IErrors {
  row: number;
  field: string;
  message: string;
}

const groupErrorsByRow = (errors: IErrors[]) => {
  return errors.reduce<Record<number, IErrors[]>>((acc, err) => {
    acc[err.row] = acc[err.row] || [];
    acc[err.row].push(err);
    return acc;
  }, {});
};

export const ErrorAlert = ({ error }: { error: IErrors[] | null }) => {
  if (!error || error.length === 0) return null;

  const groupedErrors = groupErrorsByRow(error);

  return (
    <CustomAlert severity="error">
      <AlertTitle>Validation Errors</AlertTitle>

      {Object.entries(groupedErrors).map(([row, errors]) => (
        <div key={row} style={{ marginBottom: 8 }}>
          <Typography fontWeight={600}>Row {Number(row)}</Typography>

          <List dense>
            {errors.map((e, idx) => (
              <ListItem key={idx} sx={{ pl: 2 }}>
                • <b>{e.field}</b>: {e.message}
              </ListItem>
            ))}
          </List>
        </div>
      ))}
    </CustomAlert>
  );
};

export const ImportVehicleDriverData: React.FC<
  IImportVehcileDriverDataProps
> = ({
  open,
  customer_name,
  type,
  customer_id,
  customer_policy_id,
  policy_type,
  onClose,
  onComplete,
}) => {
  const dispatch = useDispatchWrapper();
  // const [proccessCode, setProccessCode] = useState<string | null>(null);
  // const [filePath, setFilePath] = useState<string | null>(null);
  const [error, setError] = React.useState<IErrors[] | null>(null);
  const theme = useTheme();

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setValues,
    setFieldValue,
  } = useFormik({
    initialValues: {
      file: null as File | null,
      customer_name: customer_name,
      customer_policy_id: customer_policy_id,
      customer_id: customer_id,
      type: type,
      policy_type: policy_type,
    },
    validate: (values) => {
      const errors: any = {};
      if (!values.file) {
        errors.file = "File is requred!";
      }

      return errors;
    },
    onSubmit: async (values) => {
      try {
        setError(null);
        dispatch(saveLoaderProgress());

        const asPayload = {
          customer_id: values.customer_id,
          customer_policy_id: values.customer_policy_id,
          policy_type: values.policy_type,
          page_name: values.customer_name
        };
        const path = await uploadFile(values.file, "POLICY", "", asPayload);
        const res = await api.post(
          `/policy/insert-excel-or-csv-data-into-vehicle-or-driver`,
          {
            url: path,
            customer_name: values.customer_name,
            customer_policy_id: values.customer_policy_id,
            customer_id: values.customer_id,
            type: values.type,
            policy_type: values.policy_type,
          }
        );
        const errors: IErrors[] = res.data.data.errors;
        if (errors.length > 0) {
          setError(errors);
        } else {
          dispatch(
            showMessage({
              type: "success",
              message: "The imported data was saved successfully.",
              displayAs: "snackbar",
            })
          );
          onComplete();
        }
      } catch (err: any) {
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      } finally {
        dispatch(saveLoaderCompleted());
      }
    },
  });

  //   const fetchData = (proccessCode: string, interval?: any) => {
  //     dispatch(
  //       getUploadedPdfProccess(proccessCode, (isSuccess, data) => {
  //         if (isSuccess && data) {
  //           if (data.status === "COMPLETED") {
  //             clearInterval(interval);
  //             dispatch(
  //               addQuoterAfterARSUploaded(
  //                 values,
  //                 initialQuoteReqState["quote"],
  //                 filePath || "",
  //                 (isSuccess) => {
  //                   if (isSuccess) {
  //                     onComplete();
  //                     setState(data);
  //                   }
  //                 }
  //               )
  //             );
  //           } else if (data.status === "FAILED") {
  //             setState(data);
  //             clearInterval(interval);
  //             setError(ERROR_MESSAGES.SERVER_ERROR);
  //           }
  //         }
  //       })
  //     );
  //   };

  //   React.useEffect(() => {
  //     let interval: any;
  //     if (proccessCode) {
  //       interval = setInterval(() => {
  //         fetchData(proccessCode, interval);
  //       }, 10000);
  //     }

  //     return () => {
  //       clearInterval(interval);
  //     };
  //   }, [proccessCode]);

  //   if (proccessCode) {
  //     if (!state || state.status === "IN_PROGRESS") {
  //       return (
  //         <>
  //           {/* <Breadcrumb
  //                     title="Extract Products"
  //                     items={BCrumb}
  //                 /> */}
  //           <ProgressCard
  //             heading="Your document is being processed....!"
  //             subText="This may take a few moments. We're retrieving data from your document."
  //           />
  //         </>
  //       );
  //     }
  //     if (state.status === "FAILED") {
  //       return (
  //         <>
  //           {/* <Breadcrumb
  //                     title="Extract Products"
  //                     items={BCrumb}
  //                 /> */}
  //           <Stack>
  //             <ProgressCard
  //               isError={true}
  //               heading={"There was an error processing your document."}
  //               subText={"Please try again later or check the document format."}
  //             />
  //             <Button
  //               variant="contained"
  //               onClick={() => {
  //                 setFilePath(null);
  //                 setProccessCode(null);
  //               }}
  //             >
  //               Retry
  //             </Button>
  //           </Stack>
  //         </>
  //       );
  //     }
  //   }

  const handleDownload = () => {
    const link = document.createElement("a");
    if (type === "VEHICLE") {
      link.href = "/sampleFiles/vehicle_import_sample.xlsx";
      link.download = "vehicles_sample.xlsx";
    } else {
      link.href = "/sampleFiles/driver_import_sample.xlsx";
      link.download = "driver_import_sample.xlsx";
    }
    link.click();
  };

  return (
    <Dialog
      title="Import"
      fullWidth
      size="sm"
      onClose={onClose}
      open={open}
      contentWrappedWithForm={{
        onSubmit: handleSubmit,
      }}
      actions={[
        {
          label: "Save",
          type: "submit",
          variant: "contained",
        },
      ]}
    >
      {error && <ErrorAlert error={error} />}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomFormLabel>Customer Name</CustomFormLabel>
          <CustomTextField
            fullWidth
            name="customer_name"
            value={values.customer_name}
            disabled
          />
        </Grid>

        <Grid item xs={12}>
          <CustomFormLabel>For</CustomFormLabel>
          <CustomTextField
            fullWidth
            name="customer_name"
            value={values.type}
            disabled
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <CustomFormLabel>File</CustomFormLabel>
          <FileUpload
            value={""}
            onChange={(file) => setFieldValue("file", file)}
            onDelete={() => {
              setFieldValue("file", null);
            }}
          />
          {errors.file && <ErrorMessage value={errors.file} />}
        </Grid>
        <Grid item xs={12} mt={2}>
          <Stack direction={"row"} justifyContent={"end"}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              onClick={handleDownload}
              sx={{
                p: 1,
                borderRadius: "5px",
                backgroundColor: theme.palette.grey[100],
                cursor: "pointer",
              }}
              spacing={1}
            >
              <DownloadForOfflineOutlined />
              <Typography variant="body1" fontWeight={600}>
                Download Sample File
              </Typography>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Dialog>
  );
};
